<template>
  <form @submit.prevent="onContinue">
    <p class="pb-4 font-bold md:text-2xl md:pb-6">
      {{ tr('pages.sales.buy.selector.title') }}
    </p>
    <div class="flex flex-wrap justify-between mb-4">
      <TextInput
        v-model="desiredAmount"
        :placeholder="tr('pages.sales.buy.desiredAmount.label.chf')"
        :label="tr('pages.sales.buy.desiredAmount.label.chf')"
        :error="desiredAmountError"
      />
    </div>

    <div class="flex flex-wrap justify-between mb-4">
      <Select
        v-model="numberOfVouchers"
        :options="voucherNumberOptions"
        :reduce="option => option.value"
        :label="tr('pages.sales.buy.numberOfVouchers.label.chf')"
        :error="numberOfVouchersError"
      />
    </div>

    <Alert
      class="my-8"
      variant="info"
      :title="tr('pages.sales.buy.disclaimer.title')"
      :message="tr('pages.sales.buy.disclaimer.text')"
    />

    <div class="max-w-70">
      <Button
        variant="primary"
        :loading="isLoading"
        type="submit"
      >
        {{ tr('pages.sales.buy.selector.continue') }}
      </Button>
    </div>
  </form>
</template>

<script>
import TextInput from '~brand-components/swiss/shared/text-input.vue'
import VoucherAmountSelector from '~brand-components/base/sale/voucher-amount-selector'
import Alert from '~brand-components/swiss/alert/alert'
import Button from '~brand-components/swiss/button/button.vue'
import Select from '~brand-components/swiss/select/select.vue'
export default VoucherAmountSelector.extend({
  components: {
    TextInput,
    Alert,
    Button,
    Select,
  },
  computed: {
    currencyOptions() {
      return [
        { code: 'chf', label: 'CHF' },
      ]
    },
    defaultCurrency() {
      return 'chf'
    },
  },
})
</script>
